import { Component, Input } from '@angular/core';

import * as clipboard from 'clipboard-polyfill';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-copy-to-clipboard-button',
	template: require('./copy-to-clipboard-button.component.html'),
	styles: [require('./copy-to-clipboard-button.component.scss')],
})
export class CopyToClipboardButtonComponent {
	@Input() target = '';

	constructor(private readonly toastrService: ToastrService) {}

	copy(): void {
		const target = this.target.toString();
		if (!target) return;
		clipboard
			.writeText(target)
			.then(() => this.toastrService.success(`'${_.truncate(target, { length: 100 })}' copied to clipboard`))
			.catch(() => this.toastrService.success(`Could not copy to clipboard`));
	}
}
